import { newsswitchConstants } from "../constants";


export function newsswitch(state = 0, action) {
    switch (action.type) {
        case newsswitchConstants.ALL_NEWS:
            return 0;
        case newsswitchConstants.SAVED_NEWS:
            return 1;
        default:
            return state;
    }
}
